"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = __importDefault(require("./app"));
var store_1 = __importStar(require("./store"));
var errors_1 = __importDefault(require("./config/errors"));
/**
 * Returns function that either creates toast with server error response message
 * or with given callback message if server message is invalid.
 *
 * @param callbackMessage
 * @return function
 */
function serverErrorMessage(callbackMessage) {
    return function (error) {
        if (typeof callbackMessage === "string") {
            if (error.response && error.response.data && typeof error.response.data === "string") {
                app_1.default.$notification("danger", error.response.data);
            }
            else {
                app_1.default.$notification("danger", callbackMessage);
            }
        }
        else {
            if (!error.response || !error.response.data) {
                app_1.default.$notification("danger", errors_1.default.common.unrecognizedError);
                return;
            }
            var data = error.response.data;
            var hasError = false;
            if (data.errors) {
                for (var _i = 0, _a = callbackMessage.errors; _i < _a.length; _i++) {
                    var messageAttribute = _a[_i];
                    if (data.errors.hasOwnProperty(messageAttribute)) {
                        hasError = true;
                        app_1.default.$notification("danger", data.errors[messageAttribute][0]);
                    }
                }
            }
            var status_1 = error.response.status;
            if (!hasError) {
                var responseData = error.response.data;
                if (typeof responseData === "string") {
                    app_1.default.$notification("danger", (status_1 ? (status_1 + ": ") : "") + responseData);
                }
                else if (typeof callbackMessage.default === "string") {
                    app_1.default.$notification("danger", (status_1 ? (status_1 + ": ") : "") + callbackMessage.default);
                }
                else {
                    app_1.default.$notification("danger", errors_1.default.common.unrecognizedError);
                }
            }
        }
    };
}
exports.serverErrorMessage = serverErrorMessage;
/**
 * Performs GET request using store axios instance and returns a promise of that request.
 *
 * @param url
 * @param onComplete
 * @param onError
 * @return Promise
 */
function getRequest(url, params, onComplete, onError, setLoading) {
    if (setLoading === void 0) { setLoading = true; }
    if (setLoading) {
        store_1.default.commit(store_1.Mutation.setLoading);
    }
    return store_1.default.state.axios.get(url, { params: params })
        .then(onComplete)
        .catch(onError)
        .finally(function () {
        if (setLoading) {
            store_1.default.commit(store_1.Mutation.setLoading, false);
        }
    });
}
exports.getRequest = getRequest;
/**
 * Performs POST request using given data and store axios instance and returns a promise of that request.
 *
 * @param url
 * @param data
 * @param onComplete
 * @param onError
 * @return Promise
 */
function postRequest(url, data, onComplete, onError, setLoading) {
    if (setLoading === void 0) { setLoading = true; }
    if (setLoading) {
        store_1.default.commit(store_1.Mutation.setLoading);
    }
    return store_1.default.state.axios.post(url, data)
        .then(onComplete)
        .catch(onError)
        .finally(function () {
        if (setLoading) {
            store_1.default.commit(store_1.Mutation.setLoading, false);
        }
    });
}
exports.postRequest = postRequest;
